import { PropertyStateFields, PropertyStateFieldsConfigProp } from '@hcs/types';

export const PROPERTY_SUMMARY_DETAILS_DEFAULT_FIELDS_SALE: PropertyStateFieldsConfigProp =
  [
    PropertyStateFields.currentPrice,
    PropertyStateFields.currentStatusDate,
    [
      PropertyStateFields.bedrooms,
      PropertyStateFields.bathrooms,
      PropertyStateFields.livingArea,
    ],
    PropertyStateFields.currentStatus,
  ];
export const PROPERTY_SUMMARY_DETAILS_DEFAULT_FIELDS_RENTAL: PropertyStateFieldsConfigProp =
  [
    PropertyStateFields.currentPriceRental,
    PropertyStateFields.currentStatusDateRental,
    [
      PropertyStateFields.bedrooms,
      PropertyStateFields.bathrooms,
      PropertyStateFields.livingArea,
    ],
    PropertyStateFields.currentStatusRental,
  ];
